import {
  byValue,
  actividades,
  ocupaciones,
  provincias,
  situacionesLaborales,
  PCG7
} from "@/config/constants";
import { normalizeCharacters } from "../utils";

export default {
  //Obtener la ruta actual del state
  getRoute: state => () => state.route,

  // Obtener la respuesta mockeada
  getMock: state => () => state.mock,

  // Obtener la validacion de renaper
  getConfirmarRenaper: state => () => state.confirmarRenaper,

  //Obtener el model + datos del paso 1
  getPaso1: state => () => state.paso1,

  //Obtener el model + datos del paso 2
  getPaso2: state => () => state.paso2,

  //Obtener el model + datos del paso 3
  getPaso3: state => () => state.paso3,

  //Obtener el model + datos del paso 4
  getPaso4: state => () => state.paso4,

  getSucursal: state => () => state.sucursal,
  getSucursales: state => () =>
    state.sucursales.sort((a, b) => a.distance - b.distance),

  getCBU: state => () => state.graciasCA.cbu,
  getCBUPaq: state => () => state.gracias.cbu,
  getCBUcontratacion: state => () => state.respuestaContratacion.cbu,
  getTCode: state => () => state.tcode,
  getStatusSocialNet: state => () => state.socialNet.status,
  getConsulta: state => () => state.consulta,
  getForzarDNE: state => () => state.forzarDNE,
  getPaquetesBeneficios: state => () => state.paquetesBeneficios,
  getOferta: state => () => state.dataOferta.oferta,
  getAdobeTargetExperience: state => () => state.adobeTargetExperience,
  getDataOferta: state => () => state.dataOferta,
  getDataQuery: state => () => state.dataQuery,
  getNumeroCliente: state => () => state.oferta.numeroCliente,
  /**
   * @deprecated
   */
  getValidacionDomicilio: state => () => {
    return {
      randomKey: state.dataOferta.randomkey,
      domicilio: {
        calle: state.paso1.domicilioParticular.calle,
        numero: state.paso1.domicilioParticular.numero,
        piso: state.paso1.domicilioParticular.piso,
        departamento: state.paso1.domicilioParticular.dpto,
        codigoPostal: state.paso1.domicilioParticular.codigoPostal,
        //   barrio : state.paso1.domicilioParticular.calle,
        localidad: state.paso1.domicilioParticular.localidad,
        provincia: state.paso1.domicilioParticular.codProvincia
      }
    };
  },
  /**
   * @deprecated
   */
  getValidacionDomicilioOtro: state => () => {
    return {
      randomKey: state.dataOferta.randomkey,
      domicilio: {
        calle: state.paso4.otroDomicilio.calle,
        numero: state.paso4.otroDomicilio.numero,
        piso: state.paso4.otroDomicilio.piso,
        departamento: state.paso4.otroDomicilio.dpto,
        codigoPostal: state.paso4.otroDomicilio.codigoPostal,
        //   barrio : state.paso1.domicilioParticular.calle,
        localidad: state.paso4.otroDomicilio.localidad,
        provincia: state.paso4.otroDomicilio.codProvincia
      }
    };
  },
  getSearchEncontesa: state => () => state.searchEncontesa,
  getConfirmacionData: state => () => {
    let situacionLaboral = byValue(
      state.paso2.situacionLaboral,
      situacionesLaborales
    );
    let actividad = byValue(state.paso2.actividad, actividades);
    let ocupacion = byValue(state.paso2.ocupacion, ocupaciones);
    let tipoPago = state.paso4.tipoPago === "minimo" ? "0" : "1";
    let domParticularProvincia = byValue(
      state.paso1.domicilioParticular.codProvincia,
      provincias
    );
    let domOtroProvincia = byValue(
      state.paso4.otroDomicilio.codProvincia,
      provincias
    );

    return {
      cliente: {
        emailContacto: state.consulta.email,
        telContacto: {
          caracteristica: state.consulta.celular.normalizado.caracteristica,
          nro: state.consulta.celular.normalizado.nro,
          interno: "",
          area: state.consulta.celular.normalizado.area
        },
        lugarNacimiento: state.paso1.lugarNacimiento,
        tipoCuil: state.paso2.tipoCuil,
        cuil: state.paso2.cuil,
        estadoCivil: state.paso1.estadoCivil,
        conyuge: {
          tipoDocumento: state.paso1.conyuge.tipoDoc,
          numeroDocumento: state.paso1.conyuge.numeroDoc,
          apellido: state.paso1.conyuge.apellido,
          nombre: state.paso1.conyuge.nombre,
          nacionalidad: ""
        },
        domicilio: {
          calle: state.paso1.domicilioParticular.calle,
          numero: state.paso1.domicilioParticular.numero,
          piso: state.paso1.domicilioParticular.piso,
          depto: state.paso1.domicilioParticular.dpto,
          codigoPostal: state.paso1.domicilioParticular.codigoPostal,
          localidad: state.paso1.domicilioParticular.localidad,
          codProvincia: domParticularProvincia.value,
          referencia: ""
        },

        domAlternativo: {
          calle:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.calle
              : state.paso1.domicilioParticular.calle,
          numero:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.numero
              : state.paso1.domicilioParticular.numero,
          piso:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.piso
              : state.paso1.domicilioParticular.piso,
          depto:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.dpto
              : state.paso1.domicilioParticular.dpto,
          codigoPostal:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.codigoPostal
              : state.paso1.domicilioParticular.codigoPostal,
          localidad:
            state.paso4.selectDomicilio === "otro"
              ? state.paso4.otroDomicilio.localidad
              : state.paso1.domicilioParticular.localidad,
          codProvincia:
            state.paso4.selectDomicilio === "otro"
              ? domOtroProvincia.value
              : domParticularProvincia.value,
          referencia: ""
        },
        situacionLaboral: situacionLaboral.value,
        tipoActividad: actividad.value,
        tipoOcupacion: ocupacion.value,
        tipoPagoTarjeta: tipoPago,
        marcaPEP: !!Number(state.paso3.pep),
        marcaSujetoObligado: !!Number(state.paso3.sujetoObligado),
        constanciaSujetoObligado: false,
        actividadSujetoObligado: state.paso3.actividadSujetoObligado,
        eResumen: state.paso4.resumenDigital,
        eResumenEmail: state.paso4.email
      },
      deviceId: state.deviceId,
      deviceIdTimestamp: state.deviceIdTimestamp,
      producto: {
        solicitudSucursal: state.paso4.sucursal
          ? (state.paso4.sucursal + "").padStart(4, "0")
          : "0999"
      },
      randomKey: state.dataOferta.randomkey
    };
  },
  getEnvioSms: state => () => state.envioSms,
  getDatosPersonales: state => () => state.datosPersonales,
  getDatosLaborales: state => () => state.datosLaborales,
  getTieneCoordenadas: state => () =>
    !!state.domicilio.coorX &&
    !!state.domicilio.coorY &&
    state.domicilio.coorX !== "00.000000" &&
    state.domicilio.coorY !== "00.000000",
  getDomicilio: state => tDomic => {
    if (tDomic === PCG7.TDOMIC.CORRESPONDENCIA) {
      return state.domicilioAlternativo;
    }
    return state.domicilio;
  },
  getLocalidadesAgregadasByProv: state => codProv =>
    state.localidadesAgregadas[codProv],
  getInformacionAdicional: state => () => state.informacionAdicional,
  getIdentidad: state => () => state.identidad,
  getKeyLoginVeridas: state => () => state.dataVeridas.key,
  getDeviceId: state => () => state.deviceId,
  getDeviceIdTimestamp: state => () => state.deviceIdTimestamp,
  getErrorVeridas: state => () => state.errorVeridas,
  getError: state => () => state.error,
  getConfiguracion: state => () => state.configuracion,
  getResultVeridas: state => () => state.getResultVeridas,
  getConfirmacionDataVeridas: state => () => {
    let situacionLaboral = byValue(
      state.datosLaborales.situacionLaboral,
      situacionesLaborales
    );
    let actividad = byValue(state.datosLaborales.actividad, actividades);
    let ocupacion = byValue(state.datosLaborales.ocupacion, ocupaciones);
    let domParticularProvincia = byValue(
      state.datosPersonales.domicilioParticular.provincia,
      provincias
    );
    let domOtroProvincia = byValue(
      state.configuracion.otroDomicilio.provincia,
      provincias
    );
    let { area, caracteristica, nro } = state.consulta.celular.normalizado;
    return {
      cliente: {
        idGoogle: state.idGoogle,
        gclidGoogle: state.gclidGoogle,
        emailContacto: state.consulta.email,
        telContacto: {
          area,
          caracteristica,
          nro,
          interno: ""
        },
        telCompania: state.consulta.celular.compania,
        lugarNacimiento: normalizeCharacters(
          state.datosPersonales.lugarNacimiento
        ),
        tipoCuil: state.datosLaborales.tipoCuil,
        cuil: state.datosLaborales.cuil,
        estadoCivil: state.datosPersonales.estadoCivil,
        conyuge: {
          tipoDocumento: state.datosPersonales.conyuge.tipoDoc,
          numeroDocumento: state.datosPersonales.conyuge.numeroDoc,
          apellido: normalizeCharacters(state.datosPersonales.conyuge.apellido),
          nombre: normalizeCharacters(state.datosPersonales.conyuge.nombre),
          nacionalidad: ""
        },
        domicilio: {
          calle: normalizeCharacters(
            state.datosPersonales.domicilioParticular.calle
          ),
          numero: normalizeCharacters(
            state.datosPersonales.domicilioParticular.numero
          ),
          piso: normalizeCharacters(
            state.datosPersonales.domicilioParticular.piso
          ),
          depto: normalizeCharacters(
            state.datosPersonales.domicilioParticular.dpto
          ),
          codigoPostal: state.datosPersonales.domicilioParticular.codigoPostal,
          localidad: normalizeCharacters(
            state.datosPersonales.domicilioParticular.localidad
          ),
          codProvincia: domParticularProvincia.value,
          referencia: ""
        },
        domAlternativo: {
          calle: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.calle
              : state.datosPersonales.domicilioParticular.calle
          ),
          numero: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.numero
              : state.datosPersonales.domicilioParticular.numero
          ),
          piso: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.piso
              : state.datosPersonales.domicilioParticular.piso
          ),
          depto: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.dpto
              : state.datosPersonales.domicilioParticular.dpto
          ),
          codigoPostal: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.codigoPostal
              : state.datosPersonales.domicilioParticular.codigoPostal
          ),
          localidad: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? state.configuracion.otroDomicilio.localidad
              : state.datosPersonales.domicilioParticular.localidad
          ),
          codProvincia: normalizeCharacters(
            state.configuracion.selectDomicilio === "otro"
              ? domOtroProvincia.value
              : domParticularProvincia.value
          ),
          referencia: ""
        },
        situacionLaboral: situacionLaboral.value,
        tipoActividad: actividad.value,
        tipoOcupacion: ocupacion.value,
        marcaPEP: !!Number(state.informacionAdicional.pep),
        marcaSujetoObligado: !!Number(
          state.informacionAdicional.sujetoObligado
        ),
        constanciaSujetoObligado: false,
        actividadSujetoObligado:
          state.informacionAdicional.actividadSujetoObligado,
        eResumen: true,
        modo: "CD"
      },
      producto: {
        solicitudSucursal: state.configuracion.sucursal
          ? (state.configuracion.sucursal + "").padStart(4, "0")
          : "0999",
        modo: "CD"
      },
      deviceId: state.deviceId,
      deviceIdTimestamp: state.deviceIdTimestamp,
      randomKey: state.oferta.randomkey,
      verificationProcessId: state.DVSIframeData.id,
      hashref: state.consulta.hashref
    };
  },
  getContractsPdf: state => () => state.dataVeridas.contracts,
  getContrato: state => () => state.contrato,
  getNumeroTramite: state => () => state.configuracion.numeroTramite,
  getRandomKey: state => () => state.oferta.randomkey,
  getCelular: state => () => state.celular,
  getCuenta: state => () => state.cuenta,
  getCelularNormalizado: state => () => state.consulta.celular.normalizado,
  getDeviceUdid: state => () => state.celular.deviceUdid,
  getUsuarioClave: state => () => state.usuarioClave,
  getValidandoDomicilio: state => () => state.validandoDomicilio,
  getDataAuthASO: state => () => state.dataAuthASO,
  getVeridasId: state => () => state.DVSIframeData.id
};
